import type { PainterScheduleEvent } from './types'

export function getPainterEventAddress(event: PainterScheduleEvent) {
  return event.jobAddress ?? event.contact?.address
}
